const Error = () => {
  return <div className="app-container">Error</div>;
};

export default Error;
